import { makeOutlines } from "../../utils/commonUtils";


// Function used to convert the json editor simulation event form data into DB expected format
export const generatePayloadDataWithId = (payload, parentId, fields, messages) => {
    const data = [];

    // Handling the collection fields in the if {block} and other fields inthe else block
    if(payload != undefined && Array.isArray(payload)){
        const firstElement = payload[0];

        // Handling the collection plain fields in the if block and the collection struct field in the else block
        if(firstElement != undefined && firstElement.hasOwnProperty('field') && firstElement.hasOwnProperty('type') && firstElement.hasOwnProperty('field_id')){
            payload.forEach(item => {
                data.push({
                    field_id: firstElement.field_id,
                    value: item.value,
                    type: item.type,
                    field: firstElement.field,
                    originalType: item.originalType
                })
            })
        }else{
            let firstItemFieldIds = {};
            payload.forEach((currentItem, index) => {
                const nestedData = generatePayloadDataWithId(currentItem, parentId, fields, messages);
                nestedData.forEach(data => {
                    if(index === 0){
                        firstItemFieldIds[data.field] = data.field_id;
                    }else if(!data.field_id || data.field_id === ''){
                        data.field_id = firstItemFieldIds[data.field]
                    }
                })
                data.push(nestedData);
                
            })
        }
    }else{
        
        const payloadKeys =  Object.keys(payload);
        payloadKeys.forEach(payloadKey => {
            const currentItem = payload[payloadKey]
            // If block handles fields and else block used to go deep into the nested structure
            if(currentItem != undefined && currentItem.hasOwnProperty('field') && currentItem.hasOwnProperty('type') && currentItem.hasOwnProperty('field_id')){
                const payloadObj = {
                    field: currentItem.field !== "" ? currentItem.field : payloadKey,
                    type: currentItem.type,
                    value: currentItem.value,
                    field_id: currentItem.field_id,
                    originalType: currentItem.originalType
                }
                data.push(payloadObj);
            }else{
                const correspondingField = fields.find(field => field.parent[0].id == parentId && field.name == payloadKey);
                let obj = { field: payloadKey, is_collection: correspondingField.attributes.collection, field_id: correspondingField._id };
                const isMessageType = messages.find(item => item._id.toString() == correspondingField?.attributes?.type);
                const parent = isMessageType ? isMessageType._id : correspondingField._id;
                const nestedData = generatePayloadDataWithId(currentItem, parent, fields, messages);
                obj.children = nestedData;
                data.push(obj);
            }
        })
    }

    return data;
}



export const generatePayloadData = (payload) => {
    const data = [];
    const keys = Object.keys(payload);
    keys.forEach(key => {
        if (payload[key].hasOwnProperty('field') && payload[key].hasOwnProperty('type') && payload[key].hasOwnProperty('value')) {
            const payloadObj = {
                field: payload[key].field !== "" ? payload[key].field : key,
                type: payload[key].type,
                value: payload[key].value,
                field_id: payload[key].field_id
            }
            data.push(payloadObj);
        } else {
            let obj = { field: key };
            const nestedData = generatePayloadData(payload[key]);
            obj.children = nestedData;
            data.push(obj);
        }
    })
    return data;
}


export const customizeEventForm = (data) => {

    // For changing the size of path field 
    const pathField = document.querySelectorAll(`[data-schemapath="simulation_event.path"]`);
    if (pathField?.length > 0) {
        pathField[0]?.classList?.remove("col-md-12");
        pathField[0]?.classList?.add("col-md-6");
    }

    // For add the * for event field
    const eventField = document.querySelector(`[data-schemapath="simulation_event.event"]`);
    if (eventField) {
        const requiredLabels = eventField.querySelectorAll('.required');
        if (requiredLabels?.length > 0) {
            requiredLabels.forEach((element) => {
                const containsSpan = element.querySelector('span') !== null;
                if (!containsSpan) {
                    const asterisk = document.createElement('span');
                    asterisk.textContent = ' *';
                    asterisk.style = 'color: red;';
                    element.appendChild(asterisk);
                }
            });
        }
    }

    // For customize arguments field
    const argumentsDiv = document.querySelectorAll(`[data-schemapath="simulation_event.arguments"]`);
    if (argumentsDiv?.length > 0) {
      
        argumentsDiv[0].classList.add('arguments-container');
        // For replace argument input field with label
        const inputElements = argumentsDiv[0]?.querySelectorAll('input[disabled][readonly]');
        if (inputElements?.length > 0) {
            inputElements.forEach(inputElement => {
                const labelElement = document.createElement('p');
                labelElement.classList.add('argument-label');
                labelElement.textContent = inputElement.value;
                inputElement.parentNode.replaceChild(labelElement, inputElement);
            });
        }

        //  For removing the thead of arguments tabel
        const argumentsTable = argumentsDiv[0]?.querySelectorAll('table');
        if (argumentsTable?.length > 0) {
            const theads = argumentsTable[0].querySelectorAll('thead');
            if (theads?.length > 0) {
                argumentsTable[0].removeChild(theads[0]);
            }
            // For changing size of argument table fields
            const rows = argumentsTable[0].querySelectorAll('tbody tr');
            if (rows?.length > 0) {
                rows.forEach(row => {
                    const cells = row.querySelectorAll('td');
                    cells?.forEach((cell, index) => {
                        if (index == 2) {
                            cell?.classList?.add("col-md-6");
                        } else {
                            cell?.classList?.add("col-md-3");
                        }
                    });
                });
            }
        }
    }

    // For customize payload field
    let payloadDivs;
    if (data.payload) {
        payloadDivs = document.querySelectorAll(`[data-schemapath="simulation_event.payload"]`);
    } else {
        payloadDivs = document.querySelectorAll(`[data-schemapath="simulation_event.event.payload"]`);
    }

    if (payloadDivs?.length > 0) {
        payloadDivs.forEach(payloadDiv => {
            makeOutlines(payloadDiv, data.payload, 'simulation_event.payload')

            // For customising properties button 
            const propertiesBtn = payloadDiv.querySelectorAll('.json-editor-btn-edit_properties.json-editor-btntype-properties');
            if (propertiesBtn?.length > 0) {
                propertiesBtn.forEach(btn => {
                    btn.textContent = "Choose Field";
                    btn.title = "Choose Field";
                });
            }

            const payloadCard = payloadDiv.querySelector('.card.card-body')
            if (payloadCard) {
                payloadCard.classList.add('payload-container');
                // For replace field input field with label
                const inputElements = payloadCard.querySelectorAll('input[disabled][readonly]');
                if (inputElements?.length > 0) {
                    inputElements.forEach(inputElement => {

                        let field_type = false;
                        let field_name = false;
                        const labelElement = document.createElement('p');
                        labelElement.classList.add('field-label');
                        const fieldRequired = inputElement.parentNode.querySelector('label.required');
                        let parentElement = inputElement.parentElement;
                        
                        while (parentElement) {
                            if (parentElement.classList.contains('je-object__container')) {
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        if (parentElement) {
                            const pElement = parentElement.querySelector('p');
                            let pContent = pElement ? pElement.textContent : null;

                            const field_details = pContent ? JSON.parse(pContent) : false;
                            field_type = field_details ? field_details?.type : false ;
                            field_name = field_details ? field_details?.name : false;
                            let field_desc = field_details ? field_details?.desc : "";

                            if (pContent) {
                                pElement.style = "display: none;";
                                labelElement.setAttribute('title', pContent);
                                const inputField = parentElement.querySelector('input[id^="simulation_event[payload]"][id$="[value]"]');
                                if (inputField) {
                                    let helperText = document.createElement('span');
                                    helperText.textContent = field_desc;
                                    helperText.style.fontSize = '0.9em';
                                    helperText.style.color = 'grey';
                                    helperText.style.display = 'block';
                                    helperText.style.marginTop = '5px';
                                    inputField.parentNode.appendChild(helperText);
                                }
                            }
                            const h3Element = parentElement.querySelector('.h3');
                            if (h3Element) {
                                h3Element.style = "display: none;"
                                labelElement.textContent = h3Element.textContent;
                            } else {
                                labelElement.textContent = inputElement.value;
                            }
                        } else {
                            labelElement.textContent = inputElement.value;
                        }


                        // For adding required asterisk
                        if (fieldRequired !== null) {
                            const containsSpan = labelElement.querySelector('span') !== null;
                            if (!containsSpan) {
                                const asterisk = document.createElement('span');
                                asterisk.textContent = ' *';
                                asterisk.style = 'color: red;';
                                labelElement.appendChild(asterisk);
                            }
                        }


                        
                        if(field_type){
                            let field_type_span = document.createElement('span');
                            field_type_span.classList.add('field-type');
                            field_type_span.classList.add(`${field_name}-field-type`);
                            field_type_span.textContent = `(${field_type?.toLowerCase()})`;
                            field_type_span.style = 'color: grey;text-transform: capitalize;';
                            labelElement.appendChild(document.createElement('br'));
                            labelElement.appendChild(field_type_span);
                        }



                        inputElement.parentNode.replaceChild(labelElement, inputElement);
                    });
                }

                // For remove label from fields in payload section
                const labelElements = payloadCard.querySelectorAll('label');
                labelElements.forEach(labelElement => {
                    if (labelElement.parentNode?.classList.contains('form-group')) {
                        labelElement.parentNode.removeChild(labelElement);
                    }
                });
            }
        });
    }

}


function getTypeFromPath(obj, path) {
    if(obj == undefined || obj == null){
        return false
    }

    if(path == undefined || path == null){
        return false
    }

    const keys = path?.split('.');
    let current = obj;

    for (let key of keys) {
        if (current[key]) {
            current = current[key];
        } else {
            return false; // path does not exist
        }
    }

    return current.type;
}


export const customizeFormArray = (data) => {
    const profileData = data?.profile?.profile || data
    const paths = generateArrayPaths(profileData, 'simulation_profile.profile.profile')
    if(!paths || paths?.length == 0){
        const addButton = document.querySelectorAll('[title^="Add item"]')

        if(addButton?.length > 0){
            addButton.forEach(item => {
                item.innerHTML = 'Add item'
                item.style.cssText = `
                    border-radius: 6px;
                    background: #3f4e5c;
                    margin-top: 0.5rem;
                `
            })
        }
    }

    paths.forEach(path => {
        const container = document.querySelector(`[data-schemapath="${path}"]`)
        const btnGroup = container.querySelector(`.btn-group:last-child`)
        const title = container.querySelector('.h3.card-title');
        container.style.background = '#daeaf4';
        container.style.borderRadius = '4px';
        if(title) title.style.display = 'none'
        if(btnGroup) {
            btnGroup.style.cssText = `
                top: 1px;
                right: 1px;
                position: absolute;
            `
        }
        
        const deleteButton = btnGroup.querySelector('.json-editor-btn-delete')
        const deleteIcon = deleteButton.querySelector('i')
        deleteIcon?.classList?.add('fa-trash')
        if(deleteButton){
            deleteButton.style.cssText = `
                background: transparent;
                border: none;
                color: red;
                outline: none;
            `
        }

        const parentPath = path.split('.').slice(0, path.split('.').length - 1).join('.')
        const addItemButton = document.querySelector(`[data-schemapath="${parentPath}"] [title^="Add item"]`)

        if(addItemButton){
            addItemButton.parentElement.style.display = 'flex'
            addItemButton.innerHTML = 'Add item'
            addItemButton.style.cssText = `
                border-radius: 6px;
                background: #3f4e5c;
                margin-top: 0.5rem;
                margin-left: 4px;
            `
        }

        if(container.querySelector('.btn-group.je-object__controls')) container.querySelector('.btn-group.je-object__controls').style.display = 'none'
        container.style.margin = '4px'
        if(container.querySelector('.card-body')) container.querySelector('.card-body').style.cssText = 'background: red;'
    })  
}

export const customize = (data, baseId) => {
    const profileData = data?.profile?.profile || data
    let paths = generateArrayPaths(profileData, baseId || 'simulation_profile.profile.profile')
    
    paths = paths.filter(path => !path.includes("arguments"))
    

    if(!paths || paths?.length == 0){
        const addButton = document.querySelectorAll('[title^="Add item"]')

        if(addButton?.length > 0){
            addButton.forEach(item => {
                item.innerHTML = 'Add item'
                item.style.cssText = `
                    border-radius: 6px;
                    background: #3f4e5c;
                    margin-top: 0.5rem;
                `
            })
        }
    }

    paths.forEach(path => {
        const container = document?.querySelector(`[data-schemapath="${path}"]`)
        const btnGroup = container?.querySelector(`.btn-group:last-child`)
        const title = container?.querySelector('.h3.card-title');
        container.style.background = '#daeaf4';
        container.style.borderRadius = '4px';
        if(title) title.style.display = 'none'
        if(btnGroup) {
            btnGroup.style.cssText = `
                top: 1px;
                right: 1px;
                position: absolute;
            `
        }
        
        const deleteButton = btnGroup?.querySelector('.json-editor-btn-delete')
        const deleteIcon = deleteButton?.querySelector('i')
        const deleteItemText = deleteButton?.querySelector('span');
        if(deleteItemText){
            deleteItemText.style.display = "none"
        }
        deleteIcon?.classList?.add('fa-trash')
        if(deleteButton){
            deleteButton.style.cssText = `
                background: transparent;
                border: none;
                color: red;
                outline: none;
            `
        }

        const parentPath = path.split('.').slice(0, path.split('.').length - 1).join('.')
        const addItemButton = document.querySelector(`[data-schemapath="${parentPath}"] [title^="Add item"]`)

        if(addItemButton){
            addItemButton.parentElement.style.display = 'flex'
            addItemButton.innerHTML = 'Add item'
            addItemButton.style.cssText = `
                border-radius: 6px;
                background: #3f4e5c;
                margin-top: 0.5rem;
                margin-left: 4px;
            `
        }

        if(container.querySelector('.btn-group.je-object__controls')) container.querySelector('.btn-group.je-object__controls').style.display = 'none'
        container.style.margin = '4px'
        if(container.querySelector('.card-body')) container.querySelector('.card-body').style.cssText = 'background: red;'
    })  
}

export function generateArrayPaths(obj, currentPath = '') {
    let paths = [];
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            let newPath = currentPath ? `${currentPath}.${key}` : key;
            if (Array.isArray(obj[key])) {
                obj[key].forEach((item, index) => {
                    paths.push(`${newPath}.${index}`);
                    paths = paths.concat(generateArrayPaths(item, `${newPath}.${index}`));
                });
            } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                paths = paths.concat(generateArrayPaths(obj[key], newPath));
            }
        }
    }
    return paths;
}



export const customizeProfileForm = (data) => {
    // For add the * for event field
    const eventField = document.querySelector(`[data-schemapath="simulation_profile.profile"]`);
    if (eventField) {
        const requiredLabels = eventField.querySelectorAll('.required');
        if (requiredLabels?.length > 0) {
            requiredLabels.forEach((element) => {
                const containsSpan = element.querySelector('span') !== null;
                if (!containsSpan) {
                    const asterisk = document.createElement('span');
                    asterisk.textContent = ' *';
                    asterisk.style = 'color: red;';
                    element.appendChild(asterisk);
                }
            });
        }
    }


    // For customize payload field
    let payloadDivs;
    if (data.payload) {
        payloadDivs = document.querySelectorAll(`[data-schemapath="simulation_profile.profile"]`);
    } else {
        payloadDivs = document.querySelectorAll(`[data-schemapath="simulation_profile.profile.profile"]`);
    }



    if (payloadDivs?.length > 0) {

        payloadDivs.forEach(payloadDiv => {

            makeOutlines(payloadDiv, data.profile?.profile, 'simulation_profile.profile.profile')

            // For customising properties button 
            const propertiesBtn = payloadDiv.querySelectorAll('.json-editor-btn-edit_properties.json-editor-btntype-properties');
            if (propertiesBtn?.length > 0) {
                propertiesBtn.forEach(btn => {
                    btn.textContent = "Choose Field";
                    btn.title = "Choose Field";
                });
            }

            const payloadCard = payloadDiv.querySelector('.card.card-body')
            if (payloadCard) {
                payloadCard.classList.add('payload-container');
                // For replace field input field with label
                const inputElements = payloadCard.querySelectorAll('input[id^="simulation_profile[profile][profile]"][id$="[field]"]');

                if (inputElements?.length > 0) {
                    inputElements.forEach(inputElement => {
                        const labelElement = document.createElement('p');
                        labelElement.style.fontFamily = 'Roboto,Helvetica'
                        labelElement.classList.add('field-label');
                        const fieldRequired = inputElement.parentNode.querySelector('label.required');
                        let parentElement = inputElement.parentElement;
                        while (parentElement) {
                            if (parentElement.classList.contains('je-object__container')) {
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }

                        if (parentElement) {
                            const pElement = parentElement.querySelector('p');
                            const pContent = pElement ? pElement.textContent : null;

                            if (pContent) {
                                pElement.style = "display: none;";
                                labelElement.setAttribute('title', pContent);
                                const inputField = parentElement.querySelector('input[id^="simulation_profile[profile][profile]"][id$="[value]"]');
                                if (inputField) {
                                    let helperText = document.createElement('span');
                                    helperText.textContent = pContent;
                                    helperText.style.fontSize = '0.9em';
                                    helperText.style.color = 'grey';
                                    helperText.style.display = 'block';
                                    helperText.style.marginTop = '5px';
                                    inputField.parentNode.appendChild(helperText);
                                }
                            }
                            const h3Element = parentElement.querySelector('.h3');
                            if (h3Element) {
                                h3Element.style = "display: none;"
                                labelElement.textContent = h3Element.textContent;
                            } else {
                                labelElement.textContent = inputElement.value;
                            }
                        } else {
                            labelElement.textContent = inputElement.value;
                        }


                        // For adding required asterisk
                        if (fieldRequired !== null) {
                            const containsSpan = labelElement.querySelector('span') !== null;
                            if (!containsSpan) {
                                const asterisk = document.createElement('span');
                                asterisk.textContent = ' *';
                                asterisk.style = 'color: red;';
                                labelElement.appendChild(asterisk);
                            }
                        }
                        inputElement.parentNode.replaceChild(labelElement, inputElement);
                    });
                }

                // For remove label from fields in payload section
                const labelElements = payloadCard.querySelectorAll('label');
                labelElements.forEach(labelElement => {
                    if (labelElement.parentNode?.classList.contains('form-group')) {
                        labelElement.parentNode.removeChild(labelElement);
                    }
                });
            }
        });
    }

}


// Function for grouping simulations for display in sidebar
// USED IN SideBar.js
export const groupSimulationForDisplay = (simulations, testcases) => {

    let groupedSimulation = {};

    testcases.forEach(testCase => {
        let associatedScenarios = simulations.filter(scenario => scenario.testcase_id == testCase._id)

        groupedSimulation[testCase.name] = [...associatedScenarios]

    })


    return groupedSimulation;
}

export const getNodeNesteData = (node, sections, fields) => {


    let childrenSections = sections.filter(element => element.parent?.length > 0 && element.parent[0].id == node._id);

    let profileChildren = childrenSections.map(sec => {
        const elementAndChildren = findChildren(sec, sections, fields)
        return elementAndChildren
    })



    return profileChildren

}



const sectionAsChildrenNodes = [6]
const fieldAsChildrenNodes = [11, 17, 22]

export const findChildren = (node, sections, fields, messages, typeChangeFlag=true) => {
    try {
        
    
    if (sectionAsChildrenNodes.includes(node?.type) === true) {

        const children = sections?.filter(s => s.parent[0].id === node._id)

        node.children = []
        children.forEach(c => {
            c.children = []
            c.children.push(findChildren(c, sections, fields, messages, typeChangeFlag))
        })
        node.children = children


    }
    if (fieldAsChildrenNodes.includes(node?.type) === true) {
        const children = fields?.filter(s => s.parent[0].id === node._id)
        node.children = []
        children.forEach(c => {
            c.children = []
            c.children.push(findChildren(c, sections, fields, messages, typeChangeFlag))
        })
        node.children = children
    }
    if (node?.type === 12) {
        const children = fields?.filter(s => s.parent[0].id === node._id)
        node.children = []
        children.forEach(c => {
            c.children = []
            c.children.push(findChildren(c, sections, fields, messages, typeChangeFlag))
        })
        if (children.length > 0) {
            node.children = children
        } else {
            delete node.children
        }
    }
    // For message as type of message fields
    if (messages) {
        const message = messages.find(item => item._id.toString() == node?.attributes?.type);
        if (message) {
            if (typeChangeFlag === true) {
                node.attributes.type = message.name;
            }
            const children = fields?.filter(s => s.parent[0].id == message._id)
            children.forEach(c => {
                c.children = []
                c.children.push(findChildren(c, sections, fields, messages, typeChangeFlag))
            })
            node.children = children;
        }
    }

    return node;

    } catch (error) {
        console.error(`Finding children failed. ${error}`);
        return [];
    }
}